// extracted by mini-css-extract-plugin
export default {"row":"display-row-module__row___LutQ8","title":"display-row-module__title___dvDOU","text":"display-row-module__text___4vUQ9"};